import "./ExternalAccessionError.css";

import { DateTime } from "luxon";
import { Link } from "react-router-dom";

import { LISCaseList } from "pwapi";

import { LabList } from "custom-models/frontLoader";

import { ClinicsState } from "shared/reducers/frontLoaderReducers";
import { getLocalizedStringWithZone, getZoneString } from "shared/utils/dates";

const ExternalAccessionError = ({
  emrLabel,
  externalOrderId,
  existingCases,
  onClose,
  clinics,
  lab,
}: {
  emrLabel: string;
  externalOrderId: string;
  existingCases: LISCaseList[];
  onClose: () => void;
  clinics: ClinicsState;
  lab: LabList;
}) => {
  const clinic =
    (existingCases[0].patient?.clinic_id &&
      clinics[existingCases[0].patient?.clinic_id]) ||
    null;
  return (
    <>
      <h3>
        {emrLabel} {externalOrderId} is assigned to <br />
        {existingCases.length > 1 ? "other cases" : "another case"} for{" "}
        {clinic?.name}
      </h3>
      <div className="ExternalAccessionError__cases">
        {existingCases.map((c) => {
          return (
            <ul key={c.id} className="ExternalAccessionError__case">
              {c.accession && (
                <li>
                  <strong>Accession:</strong>
                  {c.accession}
                </li>
              )}
              <li className="ExternalAccessionError__listItem--capitalize">
                <strong>Case Status:</strong>
                {c.status}
              </li>
              <li className="ExternalAccessionError__listItem--capitalize">
                <strong>Case Type:</strong>
                {c.type}
              </li>
              <li>
                <strong>{emrLabel}:</strong>
                {c.external_order_id}
              </li>
              <li>
                <strong>Collected Date:</strong>
                {c.collected_date
                  ? getLocalizedStringWithZone(
                      DateTime.fromISO(c.collected_date),
                      DateTime.DATETIME_SHORT_WITH_SECONDS,
                      getZoneString(clinic?.location?.timezone)
                    )
                  : "-"}
              </li>
              <li>
                <strong>Received Date:</strong>
                {c.received_date
                  ? getLocalizedStringWithZone(
                      DateTime.fromISO(c.received_date),
                      DateTime.DATETIME_SHORT_WITH_SECONDS,
                      getZoneString(lab.location?.timezone)
                    )
                  : "-"}
              </li>
              <li>
                <strong>Patient:</strong>
                {c.patient?.first_name}{" "}
                {c.patient?.middle_initial
                  ? `${c.patient.middle_initial} `
                  : ""}
                {c.patient?.last_name}
              </li>
              <li>
                <strong>Patient Sex/DOB:</strong>
                {c.patient.sex} -{" "}
                {c.patient.date_of_birth &&
                  DateTime.fromFormat(c.patient.date_of_birth, "yyyy-mm-dd", {
                    zone: "UTC",
                  }).toFormat("mm/dd/yyyy")}
              </li>
              <li>
                <strong>MRN:</strong>
                {c.patient?.medical_record_number || "Missing MRN"}
              </li>
              <div />
              {!!(existingCases.length > 1) && (
                <Link
                  to={`/cases/${c.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ExternalAccessionError__viewCase"
                >
                  <button type="button" className="Button">
                    View Case
                  </button>
                </Link>
              )}
            </ul>
          );
        })}
      </div>
      <footer className="Modal__footer">
        {!!(existingCases.length === 1) && (
          <Link
            to={`/cases/${existingCases[0].id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button type="button" className="Button">
              View Case
            </button>
          </Link>
        )}
        <button className="Button" onClick={onClose}>
          Cancel
        </button>
      </footer>
    </>
  );
};

export default ExternalAccessionError;
